export default "__VITE_ASSET__DKlJVggX__"